








































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class StatusSelect extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop({ default: false }) multiple!: boolean;
  @Prop() value!: any;

  public isOpen = 1;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  pipelines: any[] = [];
  statuses: any[] = [];

  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    // Initialize localValue based on multiple mode
    if (this.multiple) {
      this.localValue = Array.isArray(this.value) ? [...this.value] : [];
    }
  }

  public mounted() {
    this.loadData();
  }

  public loadData() {
    const QNAME_STATUSES = `SELECT_COMBOBOX_LIST_STATUSES`;
    const QNAME_PIPELINES = `SELECT_COMBOBOX_LIST_PIPELINES`;

    this.$db([
      this.$q(QNAME_STATUSES)
        .select()
        .fileds({
            id: `statuses.id`,
            name: `statuses.name`,
            pipeline_id: "statuses.pipeline_id",
            code: "statuses.code",
            position: "statuses.position",
            color: "statuses.color",
            final: "statuses.final",
        })
        .order((_: any) => {
            return [
                _.asc([`statuses.position`]),
            ];
        })
        .from('statuses')
        .limit(1000),
      this.$q(QNAME_PIPELINES)
        .select()
        .fileds({
            id: `pipelines.id`,
            name: `pipelines.name`,
            code: "pipelines.code",
            position: "pipelines.position",
        })
        .order((_: any) => {
            return [
                _.asc([`pipelines.position`]),
            ];
        })
        .from('pipelines')
        .limit(1000),
    ]).then(((result: ServerResult) => {
      const pipelines = result.getOperation(QNAME_PIPELINES).getContent().documents;
      const statuses = result.getOperation(QNAME_STATUSES).getContent().documents;

      const pipesMap = pipelines.reduce((acc: any, cur: any) => {
        const id = cur.id;
        const data = { ...cur, statuses: []};
        return { ...acc, [id]: data };
      }, {});

      for(const status of statuses) {
        pipesMap[status.pipeline_id].statuses.push(
          status
        );
      }

      this.pipelines = Object.values(pipesMap);
      this.statuses = statuses;

      this.onValueChange(this.value);
    }));
  }

  @Watch('value')
  onValueChange(newVal: any) {
    console.log(newVal);
    
    if (this.multiple) {
      // Multiple mode: value is an array
      this.localValue = Array.isArray(newVal) ? [...newVal] : [];
      this.updateMultipleLabel();
    } else {
      // Single mode: original behavior
      this.localValue = newVal;

      if (this.localValue) {
        const selectdItem = this.statuses.find((item) => item.id == this.localValue);
        console.log('selectdItem', selectdItem, this.localValue);

        if (selectdItem) {
          this.selectdItemLabel = selectdItem.name;
        } else {
          this.selectdItemLabel = ''
        }
      } else {
        this.selectdItemLabel = '';
      }
    }
  }

  // Multiple mode methods
  isStatusSelected(statusId: string): boolean {
    return Array.isArray(this.localValue) && this.localValue.includes(statusId);
  }

  toggleStatus(statusId: string) {
    if (!Array.isArray(this.localValue)) {
      this.localValue = [];
    }
    
    const index = this.localValue.indexOf(statusId);
    if (index > -1) {
      // Remove status
      this.localValue.splice(index, 1);
    } else {
      // Add status
      this.localValue.push(statusId);
    }
    
    this.updateMultipleLabel();
    this.$emit('input', [...this.localValue]);
  }

  updateMultipleLabel() {
    if (!Array.isArray(this.localValue) || this.localValue.length === 0) {
      this.selectdItemLabel = '';
      return;
    }
    
    const selectedStatuses = this.localValue
      .map((id: string) => this.statuses.find((s: any) => s.id === id))
      .filter((s: any) => s);
    
    if (selectedStatuses.length === 0) {
      this.selectdItemLabel = '';
      return;
    }
    
    if (selectedStatuses.length <= 2) {
      this.selectdItemLabel = selectedStatuses.map((s: any) => s.name).join(', ');
    } else {
      // Show first 2 + count
      const firstTwo = selectedStatuses.slice(0, 2).map((s: any) => s.name).join(', ');
      const remaining = selectedStatuses.length - 2;
      this.selectdItemLabel = `${firstTwo} +${remaining}`;
    }
  }

  clearSelection() {
    this.localValue = [];
    this.selectdItemLabel = '';
    this.$emit('input', []);
  }

  // Single mode method
  updateValue(value: any) {
    this.onValueChange(value);
    this.$emit('input', value);
    (this.$refs.dropdown as any).toggle()
  }

  activeChange($event: any) {
    const width = this.$el.clientWidth;
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].style.width = width + 'px';
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].children[0].style.width = (width - 25) + 'px';
    this.dropdownActive = $event;
  }

}
